module.exports = __webpack_public_path__ + "img/gray.373fcf6e.svg";